module.exports = __webpack_public_path__ + "img/text_5.9096c41a.svg";